import React from "react";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error?: Error;
};

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("App crashed:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background text-foreground">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <h1 className="text-2xl md:text-3xl font-display font-bold">Something went wrong</h1>
            <p className="mt-4 text-muted-foreground">The page crashed while rendering. Please share the error below.</p>
            <pre className="mt-6 whitespace-pre-wrap rounded-xl border bg-muted/40 p-4 text-sm text-foreground/90 overflow-auto">
              {this.state.error?.message}
            </pre>
            <button
              className="mt-8 inline-flex items-center justify-center rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
